import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import genLogo from "../assets/logoWebsite.png";
import advisoryLogo from "../assets/partners/spireAdvisoryLogo.png";
import chairmanLogo from "../assets/abubaker_title.png";
import abubakerPhoto from "../assets/abubaker-photo.jpg"
import Header from "../Components/Header/Header2";
import Footer from "../Components/Footer/Footer";

export default function NewsPageItem() {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState([]);

  const id3News = (
    <span>
      GEN and SPIRE ADVISORY GROUP Announce Strategic Partnership Agreement
      South Ct Palo Alto California~USA. GEN, a leading consulting company in
      genomics and biotechnology, is pleased to announce the signing of a
      strategic partnership agreement with SPIRE ADVISORY GROUP. <br />
      This partnership aims to establish a strong connection between the two
      organizations, with the objective of addressing unmet needs in the Middle
      East, Africa, and Central Asia regions. <br />
      Through this collaboration, GEN and SPIRE ADVISORY GROUP will work
      together to foster innovation and advance the field of genomics and
      biotechnology. <br />
      By leveraging their respective expertise and resources, both organizations
      seek to make a meaningful impact in these regions, which are poised for
      significant growth and development in the life sciences sector. <br />
      The strategic partnership agreement signifies a commitment to establishing
      an active presence in Middle East, Africa, and Central Asia, where GEN and
      SPIRE ADVISORY GROUP believe there are substantial opportunities for
      collaboration and addressing unmet needs in genomics and biotechnology.{" "}
      <br />
      'We are thrilled to announce this strategic partnership with SPIRE
      ADVISORY GROUP,' said Abboud Bejjani, CEO at GEN. 'By combining our
      strengths, we aim to create a powerful network that will foster
      innovation, drive progress, and ultimately contribute to the advancement
      of genomics and biotechnology in the Middle East, Africa, and Central
      Asia.' <br />
      This partnership aligns with GEN's mission to transform lives through
      groundbreaking advancements in genomics testings and biotechnology. By
      establishing a link between innovators in this field, GEN and SPIRE
      ADVISORY GROUP aim to accelerate the development and adoption of
      cutting-edge solutions that will address unmet needs and improve
      healthcare outcomes in these regions.
    </span>
  );

  const chairmanHeader = (
    <span>
      Abubaker Seddiq Al Khoori, CFA, brings a wealth of experience and leadership to his new role. <br />As the Group CEO of Abu Dhabi Capital Group, he has demonstrated exceptional strategic acumen and financial expertise. <br />His distinguished career includes serving as the Chairman of The National Investor (TNI), and holding key leadership positions in various organizations.<br />
      Throughout his career, Abubaker has been instrumental in restructuring initiatives, financial management, and securing substantial financing for high-value developments. <br />His negotiation skills have been evident in successful mergers, including notable collaborations with Aldar Properties PJSC.<br />
      Prior to his current role, Abubaker led the private equity department at Abu Dhabi Investment Authority, where he played a pivotal role in driving success.<br />
      Abubaker Alkhoory's impressive credentials and track record make him an invaluable addition to the leadership team at GEN. His appointment reaffirms our commitment to excellence and strategic growth in the biotech sector.
    </span>
  )

  const inPageNews4 = [
    {
      id: 4,
      news: id3News,
      images: [genLogo, advisoryLogo],
      link: "",
      inPageLink: "",
    },
  ];

  const inPgaeNews1 = [
    {
      id: 1,
      news: chairmanHeader,
      images: [abubakerPhoto,chairmanLogo],
      link: "",
      inPageLink: "",
    }

  ]

  useEffect(() => {
    if (id === "4") {
      setNewsItem(inPageNews4);
    } else if (id === "1") {
      setNewsItem(inPgaeNews1);
    } else setNewsItem([]);
  }, [id]);

  return (
    <>
      <Header />
      {newsItem
        ? newsItem.map((value, index) => {
          return (
            <div key={index} className="container">
              <div className="newsPageItem">
                <div className="newsPageItem__image-container">
                  {value.images.map((value, index) => {
                    return (
                      <img
                        key={index}
                        src={value}
                        alt="image1"
                        className="newsPageItem__image"
                      />
                    );
                  })}
                </div>
                <p className="newsPageItem__paragraphe">{value.news}</p>
              </div>
            </div>
          );
        })
        : ""}
      <Footer />
    </>
  );
}
